<template>
  <CRow>
    {{ data }}
    <CCol>
      <div class="form-group" v-bind:class="{ error: group.subject_id }">
        <label>Mata Pelajaran</label>
        <subject-selector @input="changeSubject" v-model="group.subject" />
        <message-container :data="errors.subject_id" />
      </div>
    </CCol>
    <CCol>
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Kode Soal</label>
        <input
          type="text"
          class="form-control"
          v-model="group.code"
          maxlength="15"
        />
        <message-container :data="errors.entrance_major_id" />
      </div>
    </CCol>
    <CCol col="2">
      <div class="form-group" v-bind:class="{ error: errors.subject_id }">
        <label>Durasi Pengerjaan</label>
        <input
          type="number"
          class="form-control"
          v-model="group.duration"
          maxlength="15"
        />
        <message-container :data="errors.entrance_major_id" />
      </div>
    </CCol>
    <CCol col="2" v-if="group.id">
      <div class="button-group">
        <button class="btn btn-success" @click="update">Update</button>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import MessageContainer from "../../components/MessageContainer.vue";
import { HTTPAUTH } from "../../lib/httplib";
import SubjectSelector from "../../components/SubjectSelector.vue";
import { showErrorMessage } from "../../lib/helpers";
export default {
  components: {
    MessageContainer,
    SubjectSelector,
  },
  props: ["data"],
  data() {
    return {
      errors: {},
      subject: null,
      group: {
        code: "",
      },
    };
  },
  created() {
    const params = this.$route.params;
    if (params && params.id) {
      if (params.id == "new") {
        this.group = {
          code: "",
        };
      } else {
        this.getGroup(params.id);
      }
    }
  },
  methods: {
    changeDate(date) {
      this.data.period = date;
    },
    update() {
      this.$emit('doUpdate', this.group)
    },
    action(id) {
      this.$emit("update", id);
    },
    getGroup(code) {
      HTTPAUTH.get("/api/v1/admin/question-group/" + code)
        .then((res) => {
          this.group = res.data.data;
          this.$emit("update", this.group);
        })
        .catch((eres) => {
          showErrorMessage(eres);
        });
    },
    changeSubject(s) {
      this.$emit("update", this.group);
      // this.$router.push({ params: { id: s.slug } });
      this.generateGroupCode(s.slug);
    },
    generateGroupCode(slug) {
      HTTPAUTH.get("/api/v1/admin/question-group/gen/" + slug).then((res) => {
        this.group.code = res.data.data;
      });
    },
  },
};
</script>